module.exports = __webpack_public_path__ + "static/img/settings-icon.4ffac308.svg";